import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const RootProviders = lazy(() => import('@app/components/AppProviders'))
const OtaUsageLimitAlert = lazy(() => import('.'))

class OtaUsageLimitAlertComponent extends ReactWebComponent {
  static get observedAttributes() {
    return ['team-id', 'team-uuid', 'ota-usage-limit']
  }

  override render() {
    return (
      <RootProviders>
        <OtaUsageLimitAlert
          teamId={Number(this.prop('team-id'))}
          teamUuid={this.prop('team-uuid')}
          usageLimit={Number(this.prop('ota-usage-limit'))}
        />
      </RootProviders>
    )
  }
}

customElements.define('ota-usage-limit-alert', OtaUsageLimitAlertComponent)
